/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Table from "../../../core/common/dataTable/index";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { Link, useNavigate } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import { _get, _post } from "../../Utils/Helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";

const SectionSetup = () => {
  const _form = {
    query_type: "create",
    school_id: "",
    section_id: "",
    section_name: "",
    section_address: "", // Add this field to store the section address
    school_name: "",
    short_name: "YMA",
    branch_id: "", // Add this field to store the branch ID
  };

  const [form, setForm] = useState(_form);
  const [loading, setLoading] = useState(false);
  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };
  const navigate = useNavigate();
  const [new_data, setNewData] = useState([]);
  const [sections, setSections] = useState([]);
  const [branches, setBranches] = useState([]);
  const classSection = [
    { value: "Select", label: "Select" },
    { value: "NURSERY", label: "NURSERY" },
    { value: "PRIMARY", label: "PRIMARY" },
    { value: "JUNIOR SECONDARY", label: "JUNIOR SECONDARY" },
    { value: "SENIOR SECONDARY", label: "SENIOR SECONDARY" },
    { value: "ISLAMIYYA", label: "ISLAMIYYA" }
  ];
  const { school, user } = useSelector((state: RootState) => state.auth);

  const getSections = () => {
    setLoading(true);
    if (user.school_id) {
      _get(
        `get-sections?school_id=${user.school_id}`,
        (res) => {
          console.log(res);
          setLoading(false);
          setSections(res.data);
        },
        (err) => {
          setLoading(false);
          console.log(err);
        }
      );
    }
  };

  const getBranches = () => {
    setLoading(true);
    if (user.school_id) {
      _get(
        `branches?school_id=${user.school_id}&query_type=get_all`, 
        (res) => {
          console.log("API Response:", res);
          setLoading(false);
          if (res.success && res.data) {
            const branchOptions = res.data.map((branch: any) => ({
              value: branch.branch_id,
              label: branch.branch_name,
              branch_name: branch.branch_name // Assuming the API returns a location field
            }));
            setBranches(branchOptions);
          } else {
            toast.error("No branches found");
          }
        },
        (err) => {
          setLoading(false);
          console.log("API Error:", err);
          toast.error("Failed to fetch branches");
        }
      );
    }
  };

  const handleSuspend = (id: string, newStatus: string) => {
    const payload = {
      query_type: "update",
      status: newStatus,
      id: id
    };

    _post(
      "school-setup",
      payload,
      (res) => {
        if (res.success) {
          toast.success(`School ${newStatus} successfully`);
        }
      },
      (err) => {
        toast.error(err.message || "Error updating status");
      }
    );
  };

  useEffect(() => {
    getSections();
    getBranches();
  }, [user]);

  const handleSubmit = () => {
    _post(
      "section-setup",
      { ...form, short_name: school.short_name, school_id: school.school_id },
      (res) => {
        if (res.success) {
          toast.success("Submitted successfully");
          getSections();
        }
      },
      (err) => {
        toast.error(err);
        console.error("Submission failed:", err);
      }
    );
  };


  const columns = [
    {
      title: "S/N",
      dataIndex: "1",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {index + 1}
          </Link>
        </>
      )
    },
    {
      title: "Section Name",
      dataIndex: "section_name"
    },
    {
      title: "Branch",
      dataIndex: "section_address" 
    }
  ];

  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Section List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">School Setup</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sections
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption /> */}
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_section"
                  className="btn btn-primary"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Section
                </Link>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Sections List</h4>
            </div>
            <div className="card-body p-0 py-3">
              <Table
                columns={columns}
                dataSource={sections}
                Selection={false}
              />
            </div>
          </div>
        </div>
      </div>
      <>
        {/* add section modal */}
        <div className="modal fade" id="add_section">
          <div className="modal-dialog modal-dialog-centered  modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Section</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <form>
                <div className="modal-body">
                  <div className="row">
                    {/* <pre>{JSON.stringify(form)}</pre> */}
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Section Name</label>
                            <CommonSelect
                              className="select"
                              options={classSection}
                              handleChange={(newValue: any) =>
                                setForm((prev) => ({
                                  ...prev,
                                  section_id: newValue ? newValue.value : "",
                                  section_name: newValue ? newValue.label : ""
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Branch</label>
                            <CommonSelect
                              className="select"
                              options={branches}
                              // handleChange={handleBranchChange}
                              handleChange={(newValue: any) =>
                                setForm((prev) => ({
                                  ...prev,
                                  section_id: newValue ? newValue.value : "",
                                  section_address: newValue ? newValue.branch_name : ""
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => handleSubmit()}
                  >
                    Add Section
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete this School, this cant be undone once you
                    delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="modal fade" id="suspend-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-alert-circle fs-5" />
                  </span>
                  <h4>
                    Confirm
                    {school?.status === "active" ? "Suspension" : "Activation"}
                  </h4>
                  <p>
                    You want to
                    {school?.status === "active" ? "suspend" : "activate"} this
                    school
                  </p>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        if (school) {
                          handleSuspend(
                            school.school_id,
                            school.status === "active" ? "suspended" : "active"
                          );
                        }
                      }}
                    >
                      Yes,{" "}
                      {school?.status === "active" ? "Suspend" : "Activate"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default SectionSetup;